import { FullProduct } from "ts/api/product";
import { OrderProduct } from "ts/api/order";

import {
  calculateFullProductPrice,
  calculateSupplierProductsFeesAmount,
} from "tools/product/productCalculations";
import { getDiscountAmount } from "view/apps/Exhibitor/pages/Cart/helpers";
import getTaxAmount from "tools/common/getTaxAmount";
import { IShow } from "@evennt-tech/api-v2-core";

const calculateTotalSupplierPrice = (
  products: (FullProduct | OrderProduct)[],
  show: IShow,
  supplierPaymentFeeAmount = 0
) => {
  const feesAmount = calculateSupplierProductsFeesAmount({
    products,
    includeFees: true,
  });
  const productsWithoutDiscountAmount = products.reduce(
    (sum, product) =>
      sum +
      calculateFullProductPrice({
        product,
        includeFees: true,
      }),
    0
  );
  const discountAmount = getDiscountAmount(products);
  const productsAmount = Math.max(
    0,
    productsWithoutDiscountAmount - discountAmount
  );
  const subtotal = feesAmount + supplierPaymentFeeAmount + productsAmount;
  const taxAmount = getTaxAmount(subtotal, show.salesTaxPercentage);
  return { totalAmount: subtotal + taxAmount, discountAmount };
};

export default calculateTotalSupplierPrice;
